/**
 * @see https://github.com/js-cookie/js-cookie/
 */
import Cookies from 'js-cookie';

import InternationalPhoneInput from 'intl-tel-input';
import PerfectScroll from 'perfect-scrollbar';

export default {
	init() {
		setupForm();
	}
};

let phoneInput;

function setupForm() {
	let $form = $('form#job-application-form');

	setupCookie($form);
	setupFormSubmission($form);
	setupFormComplexFields($form);
}

function setupCookie($form) {
	// This will refresh every time they refresh, and if they don't refresh and submit after expiry then it should still work.
	let applicationID = $form.data('application-id'),
		jobID = $form.data('job-id'),
		expDate = new Date();

	expDate.setTime(expDate.getTime() + (15 * 60 * 1000)); // Add 15 minutes

	Cookies.set(`vibe-teamtailor-frontend-territory-studio_job_${jobID}`, applicationID, { expires: expDate });
}

function setupFormSubmission($form) {
	$form.on('submit', (e) => {
		e.preventDefault();

		if ($form.hasClass('uploading')) {
			return; // Do nothing as files are uploading;
		}

		submitForm($form);
	});
}

function submitForm($form) {
	let data = {
		action: 'vibe_teamtailor_application_ajax_submit',
		nonce: vibe_teamtailor_scriptData.vibe_teamtailor_application_ajax_submit_nonce,
		application_id: $form.data('application-id'),
		first_name: $form.find('input[name="fname"]').val(),
		last_name: $form.find('input[name="lname"]').val(),
		email: $form.find('input[name="email"]').val(),
		phone: phoneInput.getNumber(),
		portfolio: $form.find('input[name="portfolio-url"]').val(),
		linked_in: $form.find('input[name="linkedin-profile-url"]').val(),
		cover_story: $form.find('textarea[name="cover-story"]').val(),
		terms_and_conditions: $form.find('input[name="terms-and-conditions"]').is(':checked') ? 1 : 0,
	};

	$form.addClass('loading');

	$.post(vibe_teamtailor_scriptData.ajaxURL, data, (response) => {
		if (response.success) {
			// successful submission
			window.location.href = $form.data('redirect-url'); // Redirect to thank you page
		} else {
			let scrolled = false,
				headerOffset = 100;

			for (let field in response.errors) {
				if (!scrolled) {
					scrolled = true;
					$('html, body').animate({ scrollTop: $form.offset().top - headerOffset }, 1000);
				}

				addFormError($form, field, response.errors[field].message);
			}
		}

		$form.removeClass('loading');
	});
}

function uploadFile($form, type, file, tempID) {
	let formData = new FormData();

	formData.append('action', 'vibe_teamtailor_application_ajax_uploadFile');
	formData.append('nonce', vibe_teamtailor_scriptData.vibe_teamtailor_application_ajax_uploadFile_nonce);
	formData.append('file', file);
	formData.append('type', type);
	formData.append('application_id', $form.data('application-id'));

	$form.addClass('uploading');

	if (type === 'cv') {
		$form.find('.vibe-field-wrap.cv-file-wrap').addClass('loading');
		$form.find('.vibe-field-wrap.cv-file-wrap .custom-upload-box').addClass('max-uploaded');
	}

	if (type === 'additional_files') {
		$form.find('.vibe-field-wrap.additional-files-wrap').addClass('loading');
	}

	$.ajax({
		type: 'POST',
		url: vibe_teamtailor_scriptData.ajaxURL,
		xhr: function () {
			let myXhr = $.ajaxSettings.xhr();
			if (myXhr.upload) {
				myXhr.upload.addEventListener('progress', function(e) {
					let percent  = 0,
						position = event.loaded || event.position,
						total    = event.total,
						$fileCard = $form.find('.file-wrapper[data-temp-id="'+ tempID +'"]');

					if (event.lengthComputable) {
						percent = Math.ceil(position / total * 100);
						$fileCard.find('.progress-bar').css('width', percent + '%');
					}
				}, false);
			}
			return myXhr;
		},
		success: function (response) {
			uploadSuccess(response, $form, type, tempID);

			if (type === 'cv') {
				$form.find('.vibe-field-wrap.cv-file-wrap').removeClass('loading');
			}

			if (type === 'additional_files') {
				$form.find('.vibe-field-wrap.additional-files-wrap').removeClass('loading');
			}

			$form.removeClass('uploading');
		},
		error: function (error) {
			addFormError($form, type, 'Something has gone wrong please try again.');

			$form.find('.file-wrapper[data-temp-id="' + tempID + '"]').remove();

			if (type === 'cv') {
				$form.find('.vibe-field-wrap.cv-file-wrap').removeClass('loading');
			}

			if (type === 'additional_files') {
				$form.find('.vibe-field-wrap.additional-files-wrap').removeClass('loading');
			}

			$form.removeClass('uploading');

			if (type === 'cv') {
				$form.find('.cv-file-wrap .custom-upload-box').removeClass('max-uploaded');
			}
		},
		async: true,
		data: formData,
		cache: false,
		contentType: false,
		processData: false,
		timeout: 60000
	});
}

function uploadSuccess(response, $form, type, tempID) {
	if (response.success) {
		let $fileCard = $form.find('.file-wrapper[data-temp-id="' + tempID + '"]');

		$fileCard.attr('data-file-id', response.file_key);
		$fileCard.find('a.remove-file').attr('data-file-id', response.file_key);
		$fileCard.find('.file').removeClass('uploading').addClass('uploaded');
	} else {
		$form.find('.file-wrapper[data-temp-id="' + tempID + '"]').remove();
		addFormError($form, type, response.error.message);

		if (type === 'cv') {
			$form.find('.cv-file-wrap .custom-upload-box').removeClass('max-uploaded');
		}
	}
}

function removeFile($form, type, fileKey) {
	let data = {
		action: 'vibe_teamtailor_application_ajax_removeFile',
		nonce: vibe_teamtailor_scriptData.vibe_teamtailor_application_ajax_removeFile_nonce,
		file_key: fileKey,
		type: type,
		application_id: $form.data('application-id')
	};

	if (type === 'cv') {
		$form.find('.vibe-field-wrap.cv-file-wrap').addClass('loading');
	}

	if (type === 'additional_files') {
		$form.find('.vibe-field-wrap.additional-files-wrap').addClass('loading');
	}

	$.post(vibe_teamtailor_scriptData.ajaxURL, data, (response) => {
		if (response.success) {
			removeFileCard($form, $form.find('.file-wrapper[data-file-id="' + fileKey + '"]').data('temp-id'));

			if (type === 'cv') {
				$form.find('.cv-file-wrap .custom-upload-box').removeClass('max-uploaded');
			}
		} else {
			if (type === 'cv') {
				addFormError($form, 'cv', response.error.message);
			}

			if (type === 'additional_files') {
				addFormError($form, 'additional_files', response.error.message);
			}
		}

		if (type === 'cv') {
			$form.find('.vibe-field-wrap.cv-file-wrap').removeClass('loading');
		}

		if (type === 'additional_files') {
			$form.find('.vibe-field-wrap.additional-files-wrap').removeClass('loading');
		}
	});
}

function setupFormComplexFields($form) {
	setupPhoneInput($form);
	setupCVFileUploadField($form);
	setupFormMultiFileUpload($form);
}

function setupPhoneInput($form) {
	let $inputs = $form.find('input[type="tel"]');

	document.documentElement.style.setProperty('--vibe-teamtailor-frontend-job-application-phone-box-spacing', 56 + 20 + 'px');

	$inputs.each((index, item) => {
		let $input = $(item);

		$input.on('focus mouseover', function (e) {
			$(this).closest('.vibe-field-wrap').find('.phone-code').addClass('has-focus');
		});

		$input.on('focusout mouseleave', function() {
			if ($(this).not(':focus')) {
				$(this).closest('.vibe-field-wrap').find('.phone-code').removeClass('has-focus');
			}
		});

		let input = item;

		phoneInput = InternationalPhoneInput(input, {
			utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js',
			nationalMode: false,
			separateDialCode: true,
			preferredCountries: ['gb', 'us'],
		});

		setTimeout(() => {
			phoneCountryChangeEvent($input);
		}, 100);

		input.addEventListener('countrychange', function() {
			phoneCountryChangeEvent($input);
		});

		setTimeout(() => {
			let $scrollWrapper = $input.closest('.vibe-field-wrap').find('ul.iti__country-list'),
				ps = new PerfectScroll($scrollWrapper.get(0), {
					suppressScrollX: true,
				});

			$(window).smartresize(() => {
				ps.update();
			});
		}, 300);
	});
}

function phoneCountryChangeEvent($input) {
	let $wrapper = $input.closest('.vibe-field-wrap'),
		$dialCode = $wrapper.find('.phone-code'),
		selectWidth = 56,
		offset = 20;

	$dialCode.text('+' + phoneInput.getSelectedCountryData().dialCode + ' | ');

	let codeWidth = $dialCode.outerWidth();

	document.documentElement.style.setProperty('--vibe-teamtailor-frontend-job-application-phone-box-spacing', selectWidth + offset + codeWidth + 'px');
}

function setupCVFileUploadField($form) {
	let $input = $form.find('input[name="cv-file"]');

	$input.on('change', (e) => {
		if ($input.val()) {
			uploadCV($input);
		}
	});

	try {
		let $wrapper = $input.closest('.vibe-field-wrap'),
			uploadedData = JSON.parse($wrapper.find('.uploaded-files').attr('data-files'));

		if (uploadedData) {
			for (const [tempID, fileName] of Object.entries(uploadedData)) {
				$wrapper.find('.custom-upload-box').addClass('max-uploaded');
				addCVFileHtml(fileName, tempID, $wrapper, false);
			}
		}
	} catch (e) {
		console.log(e);
	}
}

function removeCV($form, fileID) {
	$form.find('input[name="cv-file"]').val(''); // Clear input

	removeFile($form, 'cv', fileID);
}

function removeFileCard($form, tempID) {
	$form.find('.uploaded-files .file-wrapper[data-temp-id="' + tempID + '"]').remove();
}

function uploadCV($input) {
	let $form = $input.closest('form'),
		filename = getFileName($input.val()),
		$wrapper = $input.closest('.vibe-field-wrap'),
		tempID = filename + '-' + Date.now();

	uploadFile($form, 'cv', $input.get(0).files[0], tempID);

	$input.val('');
	$wrapper.find('.uploaded-files').html('');

	addCVFileHtml(filename, tempID, $wrapper);
}

function addCVFileHtml(filename, tempID, $wrapper, uploading = true) {
	let $html = $('<div class="file-wrapper" data-temp-id="' + tempID +'"><div class="file ' + (uploading ? 'uploading' : '') + '"><span class="name">' + filename + '</span><a href="#!" class="remove-file"></a><div class="progress-bar-wrapper"><span class="progress-bar"></span></div></div></div>');

	$wrapper.find('.uploaded-files').append($html);

	if (!uploading) {
		const $fileCard = $wrapper.find(`[data-temp-id="${tempID}"]`);

		$fileCard.attr('data-file-id', tempID);
		$fileCard.find('a.remove-file').attr('data-file-id', tempID);
	}

	setTimeout(() => {
		$wrapper.find('a.remove-file').on('click', function (e) {
			e.preventDefault();

			if ($(this).data('file-id')) {
				removeCV($wrapper.closest('form'), $(this).data('file-id'));
			}
		});
	}, 300);
}

function setupFormMultiFileUpload($form) {
	let $inputs = $form.find('input[type="file"].multi-file-upload');

	$inputs.each((index, item) => {
		let $input = $(item);

		$input.on('change', (e) => {
			if ($input.val()) {
				uploadAdditionalFile($input);
			}
		});

		try {
			const $wrapper = $input.closest('.vibe-field-wrap');
			const uploadedData = JSON.parse($wrapper.find('.uploaded-files').attr('data-files'));

			if (uploadedData) {
				for (const [tempID, fileName] of Object.entries(uploadedData)) {
					addMultiFileCard(fileName, tempID, $wrapper, false);
				}
			}
		} catch (e) {
		}
	});
}

function uploadAdditionalFile($input) {
	let $form = $input.closest('form'),
		filename = getFileName($input.val()),
		$wrapper = $input.closest('.vibe-field-wrap'),
		tempID = filename + '-' + Date.now();

	$form.addClass('uploading');
	$wrapper.addClass('loading');

	// Ajax to upload file here
	uploadFile($form, 'additional_files', $input.get(0).files[0], tempID);

	addMultiFileCard(filename, tempID, $wrapper);
}

function addMultiFileCard(filename, tempID, $wrapper, uploading = true) {
	let $html = $('<div class="file-wrapper" data-temp-id="' + tempID + '"><div class="file ' + (uploading ? 'uploading' : '') + '"><span class="name">' + filename + '</span><a href="#!" class="remove-file"></a><div class="progress-bar-wrapper"><span class="progress-bar"></span></div></div></div>');

	$wrapper.find('.uploaded-files').append($html);

	if (!uploading) {
		const $fileCard = $wrapper.find(`[data-temp-id="${tempID}"]`);

		$fileCard.attr('data-file-id', tempID);
		$fileCard.find('a.remove-file').attr('data-file-id', tempID);
	}

	$wrapper.find('.file-wrapper[data-temp-id="' + tempID +'"] a.remove-file').on('click', function (e) {
		e.preventDefault();

		if ($(this).data('file-id')) {
			removeAdditionalFile($(this).data('file-id'), $wrapper);
		}
	});
}

function removeAdditionalFile(fileID, $wrapper) {
	// Add removing AJAX here
	removeFile($wrapper.closest('form'), 'additional_files', fileID);
}

function getFileName(filepath) {
	return filepath.replace(/C:\\fakepath\\/i, '');
}

function addFormError($form, field, error) {
	clearFieldError($form, field); // Remove current error
	addFormHasErrorsMessage($form);

	let $errorHtml = $('<div class="error-notice">' + error + '</div>');

	switch (field) {
		case 'first_name' :
			$form.find('.first-name-wrap input').addClass('error');
			$form.find('.first-name-wrap input').on('change', {field: field}, errorFieldChangeEvent);
			$form.find('.first-name-wrap').append($errorHtml);

			break;
		case 'last_name' :
			$form.find('.last-name-wrap input').addClass('error');
			$form.find('.last-name-wrap input').on('change', {field: field}, errorFieldChangeEvent);
			$form.find('.last-name-wrap').append($errorHtml);

			break;
		case 'email' :
			$form.find('.email-wrap input').addClass('error');
			$form.find('.email-wrap input').on('change', {field: field}, errorFieldChangeEvent);
			$form.find('.email-wrap').append($errorHtml);

			break;
		case 'phone' :
			$form.find('.phone-number-wrap input').addClass('error');
			$form.find('.phone-number-wrap input').on('change', {field: field}, errorFieldChangeEvent);
			$form.find('.phone-number-wrap').append($errorHtml);

			break;
		case 'portfolio' :
			$form.find('.portfolio-url-wrap input').addClass('error');
			$form.find('.portfolio-url-wrap input').on('change', {field: field}, errorFieldChangeEvent);
			$form.find('.portfolio-url-wrap').append($errorHtml);

			break;
		case 'linked_in' :
			$form.find('.linkedin-profile-url-wrap input').addClass('error');
			$form.find('.linkedin-profile-url-wrap input').on('change', {field: field}, errorFieldChangeEvent);
			$form.find('.linkedin-profile-url-wrap').append($errorHtml);

			break;
		case 'cv' :
			$form.find('.cv-file-wrap input').addClass('error');
			$form.find('.cv-file-wrap input').on('change', {field: field}, errorFieldChangeEvent);
			$form.find('.cv-file-wrap').append($errorHtml);

			break;
		case 'additional_files' :
			$form.find('.additional-files-wrap input').addClass('error');
			$form.find('.additional-files-wrap input').on('change', {field: field}, errorFieldChangeEvent);
			$form.find('.additional-files-wrap').append($errorHtml);

			break;
		case 'cover_story' :
			$form.find('.cover-story-wrap textarea').addClass('error');
			$form.find('.cover-story-wrap textarea').on('change', {field: field}, errorFieldChangeEvent);
			$form.find('.cover-story-wrap').append($errorHtml);

			break;
		case 'terms_and_conditions' :
			$form.find('.terms-and-conditions-wrap input').addClass('error');
			$form.find('.terms-and-conditions-wrap input').on('change', {field: field}, errorFieldChangeEvent);
			$form.find('.terms-and-conditions-wrap').append($errorHtml);

			break;
	}
}

function clearFieldError($form, field) {
	switch (field) {
		case 'first_name' :
			$form.find('.first-name-wrap input').removeClass('error');
			$form.find('.first-name-wrap .error-notice').remove();

			break;
		case 'last_name' :
			$form.find('.last-name-wrap input').removeClass('error');
			$form.find('.last-name-wrap .error-notice').remove();

			break;
		case 'email' :
			$form.find('.email-wrap input').removeClass('error');
			$form.find('.email-wrap .error-notice').remove();

			break;
		case 'phone' :
			$form.find('.phone-number-wrap input').removeClass('error');
			$form.find('.phone-number-wrap .error-notice').remove();

			break;
		case 'portfolio' :
			$form.find('.portfolio-url-wrap input').removeClass('error');
			$form.find('.portfolio-url-wrap .error-notice').remove();

			break;
		case 'linked_in' :
			$form.find('.linkedin-profile-url-wrap input').removeClass('error');
			$form.find('.linkedin-profile-url-wrap .error-notice').remove();

			break;
		case 'cv' :
			$form.find('.cv-file-wrap input').removeClass('error');
			$form.find('.cv-file-wrap .error-notice').remove();

			break;
		case 'additional_files' :
			$form.find('.additional-files-wrap input').removeClass('error');
			$form.find('.additional-files-wrap .error-notice').remove();

			break;
		case 'cover_story' :
			$form.find('.cover-story-wrap textarea').removeClass('error');
			$form.find('.cover-story-wrap .error-notice').remove();

			break;
		case 'terms_and_conditions' :
			$form.find('.terms-and-conditions-wrap input').removeClass('error');
			$form.find('.terms-and-conditions-wrap .error-notice').remove();

			break;
	}

	if ($form.find('.error').length === 0) {
		removeFormHasErrorsMessage($form);
	}
}

function errorFieldChangeEvent(e) {
	$(this).removeClass('error');
	$(this).closest('.vibe-field-wrap').find('.error-notice').remove();

	clearFieldError($(this).closest('form'), e.data.field);

	$(this).off('change', errorFieldChangeEvent); // Remove listener after error is removed
}

function addFormHasErrorsMessage($form) {
	if ($form.find('.form-has-errors-notice').length === 0) {
		let $html = $('<div class="form-has-errors-notice">There was a problem with your submission. Errors have been highlighted below.</div>');

		$form.prepend($html);
	}
}

function removeFormHasErrorsMessage($form) {
	$form.find('.form-has-errors-notice').remove();
}